<script setup lang="ts">
import VeeTextField from '@/components/forms/TextField/VeeTextField.vue';

export interface InstallationNameProps {
  showDescription?: boolean;
}

const { showDescription = true } = defineProps<InstallationNameProps>();
</script>

<template>
  <div>
    <h4 class="mb-4">{{ $t('DefineAnInstallationName') }}</h4>
    <p v-if="showDescription">{{ $t('InstallationNameMsg') }}</p>
    <VeeTextField
      name="customerProvidedOptionalSiteName"
      class="mt-10"
      :label="$t('InstallationName')"
      :placeholder="$t('Required')"
    />
  </div>
</template>
